import axios from 'axios'
import { getApiBaseUrl } from '../utils/apiBaseUrl'

const api = axios.create({
  baseURL: getApiBaseUrl(),
})

// Add debugging to see what URL is being used
console.log('API Base URL:', getApiBaseUrl())

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    // Skip adding token for health and login endpoints
    const publicAuthPaths = [
      '/health',
      '/auth/login',
      '/auth/request-account-deletion',
      '/auth/confirm-account-deletion',
      '/auth/forgot-password',
    ]
    if (publicAuthPaths.some((path) => config.url?.includes(path))) {
      return config;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('API Error:', error.response?.status, error.response?.statusText, error.config?.url)
    if (error.response?.status === 401) {
      console.log('401 Unauthorized error detected')
      // Handle unauthorized access
      localStorage.removeItem('token');
      // Only redirect if not already on login page to prevent infinite loops
      const publicPaths = ['/login', '/deleteAccount', '/reset-password']
      const onPublicPath = publicPaths.some((p) => window.location.pathname.startsWith(p))
      if (!onPublicPath) {
        console.log('Redirecting to login page')
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
